<template>
  <v-table>
    <thead v-if="tableMode === 'accounting'">
      <th>{{ $t(`finances.table.accounting.invoiceDate`) }}</th>
      <th>{{ $t(`finances.table.accounting.maturityDate`) }}</th>
      <th>{{ $t(`finances.table.accounting.backlogDays`) }}</th>
      <th>{{ $t(`finances.table.accounting.order`) }}</th>
      <th>{{ $t(`finances.table.accounting.yourOrder`) }}</th>
      <th>{{ $t(`finances.table.accounting.invoice`) }}</th>
      <th>{{ $t(`finances.table.accounting.typeOfMovement`) }}</th>
      <th>{{ $t(`finances.table.accounting.details`) }}</th>
      <th>{{ $t(`finances.table.accounting.debit`) }}</th>
      <th>{{ $t(`finances.table.accounting.sum`) }}</th>
      <th>{{ $t(`finances.table.accounting.currency`) }}</th>
    </thead>
    <thead v-if="tableMode === 'catalogue'">
      <th>{{ $t(`finances.table.catalogue.balanceDate`) }}</th>
      <th>{{ $t(`finances.table.catalogue.valueDate`) }}</th>
      <th>{{ $t(`finances.table.catalogue.referenceTwo`) }}</th>
      <th>{{ $t(`finances.table.catalogue.details`) }}</th>
      <th>
        {{ $t(`finances.table.catalogue.counterAccountDescription`) }}
      </th>
      <th>{{ $t(`finances.table.catalogue.noJournalMovement`) }}</th>
      <th>{{ $t(`finances.table.catalogue.typeOfMovement`) }}</th>
      <th>{{ $t(`finances.table.catalogue.debit`) }}</th>
      <th>{{ $t(`finances.table.catalogue.credit`) }}</th>
      <th>{{ $t(`finances.table.catalogue.cumulativeBalance`) }}</th>
      <th>{{ $t(`finances.table.catalogue.currency`) }}</th>
    </thead>
    <tbody v-if="tableMode === 'accounting'">
      <tr v-for="finance in financesList" :key="finance.ord">
        <td>{{ formatDate(finance.invoiceDate) }}</td>
        <td>{{ formatDate(finance.maturityDate) }}</td>
        <td>{{ finance.backlogDays }}</td>
        <td>{{ finance.order }}</td>
        <td>{{ finance.ord }}</td>
        <td>{{ finance.invoice }}</td>
        <td>{{ finance.typeOfMovement }}</td>
        <td class="details">{{ finance.details }}</td>
        <td>{{ finance.debit.toLocaleString() }}</td>
        <td>{{ finance.sum.toLocaleString() }}</td>
        <td>{{ finance.currency }}</td>
      </tr>
    </tbody>
    <tbody v-if="tableMode === 'catalogue'">
      <tr v-for="catalogue in catalogueList" :key="catalogue">
        <td>{{ formatDate(catalogue.balanceDate) }}</td>
        <td>{{ formatDate(catalogue.valueDate) }}</td>
        <td>{{ catalogue.referenceTwo }}</td>
        <td class="details">{{ catalogue.details }}</td>
        <td class="details">{{ catalogue.counterAccountDescription }}</td>
        <td>{{ catalogue.noJournalMovement }}</td>
        <td>{{ catalogue.typeOfMovement }}</td>
        <td>{{ catalogue.debit.toLocaleString() }}</td>
        <td>{{ catalogue.credit.toLocaleString() }}</td>
        <td>{{ catalogue.cumulativeBalance.toLocaleString() }}</td>
        <td>{{ catalogue.currency }}</td>
      </tr>
    </tbody>
    <tfoot v-if="financesList.length && tableMode === 'accounting'">
      <th>סה"כ</th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th class="font-weight-normal">{{ sum("debit") }}</th>
      <th class="font-weight-normal">{{ sum("sum") }}</th>
      <th></th>
    </tfoot>
    <tfoot v-if="catalogueList.length && tableMode === 'catalogue'">
      <th>סה"כ</th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th class="font-weight-normal">{{ sum("debit") }}</th>
      <th class="font-weight-normal">{{ sum("credit") }}</th>
      <th class="font-weight-normal">{{ sum("cumulativeBalance") }}</th>
      <th></th>
    </tfoot>
  </v-table>
</template>

<script>
import moment from "moment";

export default {
  props: ["tableMode", "financesList", "catalogueList"],
  methods: {
    formatDate(senddate) {
      return moment(senddate).format("DD/MM/YY");
    },
    sum(type) {
      if (this.tableMode === "accounting") {
        if (!this.financesList) return 0;
        const sum = this.financesList.reduce((acc, cur) => acc + cur[type], 0);
        return sum.toLocaleString();
      } else if (this.tableMode === "catalogue") {
        if (!this.catalogueList) return 0;
        const sum = this.catalogueList.reduce((acc, cur) => acc + cur[type], 0);
        return sum.toLocaleString();
      }
    },
  },
};
</script>

<style lang="scss">
@media only screen and (max-width: 601px) {
  .v-table__wrapper {
    overflow: scroll;
    max-height: 500px;
  }
}
</style>
<style scoped lang="scss">
@media only screen and (max-width: 1440px) {
  thead th {
    font-size: 15px !important;
    min-width: 100px;
  }
  tbody td {
    font-size: 15px !important;
    min-width: 100px;
  }

  tbody td.details {
    min-width: 150px;
  }
}
thead {
  border-radius: 0px 50px 50px 0px;
  background-color: #f5f5f5;
  th {
    font-size: $mediumTextSize;
    font-weight: 400;
    padding: 15px 0px;

    &:first-child {
      border-radius: 0px 50px 50px 0px;
    }
    &:last-child {
      border-radius: 50px 0px 0px 50px;
    }
  }
}
tr {
  height: 70px;
}
td {
  color: $orderLineColor;
  font-size: $mediumTextSize;
  text-align: center !important;
}
tfoot {
  border-radius: 0px 50px 50px 0px;
  background-color: #f5f5f5;
  color: #868686;
  th {
    font-size: $mediumTextSize;
    font-weight: 700;
    padding: 15px 0px;

    &:first-child {
      border-radius: 0px 50px 50px 0px;
    }
    &:last-child {
      border-radius: 50px 0px 0px 50px;
    }
  }
  .font-weight-normal {
    font-weight: 400;
  }
}
</style>